import React from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { get, debounce } from 'lodash';
import InputSelect from '../components/inputs/InputSelect';
import InputSelectAsync from '../components/inputs/InputSelectAsync';
import InputTextArea from '../components/inputs/InputTextArea';
import InputText from '../components/inputs/InputText';
import InputSelectAsyncCreatable from '../components/inputs/InputSelectAsyncCreatable';
import InputDate from '../components/inputs/InputDate';
import InputSpan from '../components/inputs/InputSpan';
import { API_HOST } from '../consts';
import InputCheckbox from '../components/inputs/InputCheckbox';
import InputSelectMulti from '../components/inputs/InputSelectMulti';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  IconButton,
  Button,
  Fab
} from '@material-ui/core';
import {
  FormSeparator,
} from '../pages/avaliacoes/Styled/ItemStyles';
const mapResponse = ({ id, descricao }) => ({
  value: id,
  label: descricao
});

const mapMatrizReferencia = ({ id, nome }) => ({
  value: id,
  label: nome
});

const mapEncomenda = mapMatrizReferencia;

class BaseFiltroAvancadoItem extends React.Component {
  constructor(props) {
    super(props);
    this.firstTimeOpening = true;
    this.getCursoIdInitial = true;
    this.onOpened = this.onOpened.bind(this);
    this.state = { isPublic: false, isChecked: true };
    this.handleCheck = this.handleCheck.bind(this);

  }
  handleCheck(e) {
    this.setState({
      isPublic: e.target.checked
    });
  }

  state = {
    exame: [],
    matriz_referencia: [],
    area_conhecimento: [],
    habilidades: [],
    criado_por: [],
    status: [],
    tipo: [],
    dificuldade: [],
    filtros: [],
    itens: [],
    periodo: [],
    componenteCurricular: [],
    showItens: false,
    itensChecked: [],
    metadata: {},
    codigoId: '',
    areasConhecimentoId: '',
    anoId: '',
    matrizReferenciaId: '',
    cursoId: '',
    habilidadeId: '',
    habilidadeSearch: '',
    avaliacaoPPI: false,
    idCursoInitial: '',
    areaConhecimentoID: "",
  };

  onOpened() {
    setTimeout(() => {
      if (this.firstTimeOpening) {
        this.firstTimeOpening = false;
        Promise.all([
          this.fetchMetadata(),
          this.fetchExames(),
          this.fetchAreasConhecimento(),
          this.fetchCriadoPor(),
          this.fetchComponenteCurricular(),
          this.fetchMatrizReferencia(),
          this.fetchCurso(),
          this.fetchPeriodo(),
          this.fetchStatus(),
          this.fetchTipo(),
          this.fetchDificuldades(),
          // this.fetchHabilidade(),
        ]).then(() => {

          const { initialValues } = this.props;
          this.formApi.setValues({ ...initialValues, ...this.values });

          this.getAvaliationPPI(this.formApi);
          this.getAvaliation(this.formApi)

        });
      }
    }, 1000);
  }

  componentDidUpdate() {
    if (this.getCursoIdInitial) {
      if (this.state.cursoID) {
        axios.get(`${API_HOST}/core/curso?id=${this.state.cursoID}`).then((response) => {
          this.setState({ idCursoInitial: response.data[0].codigo });
        });
        this.fetchMatrizReferencia()
        this.getCursoIdInitial = false
      }
    }

  }

  fetchMetadata() {
    axios.get(`${API_HOST}/params/param?model=avaliacao`).then((response) => {
      this.setState({ metadata: this.mapMetadata(response.data) });
    });
  }

  mapMetadata(metadata) {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });
    return mapped;
  }

  onCheckboxClick(_, id) {
    const { itensChecked } = this.state;
    itensChecked.push(id);
    this.setState({ itensChecked });
  }
  shouldDisplay(field) {
    const { metadata } = this.state;
    return get(metadata, field) > 0;
  }

  getValues(v) {
    const values = { ...v };
    this.asyncSelects.forEach((select) => {
      if (values[select]) {
        values[select] = get(values, `${select}.value`);
      }
    });
    values['habilidade'] = values['habilidade'] && values['habilidade'].join(",")
    return values;
  }

  asyncSelects = [
    'matriz_referencias',
    'competencia',
    'habilidades',
    'encomenda',
    'componente_curriculares',
    'curso',
    'periodos'
  ];

  fetchExames() {
    const params = { type: 'itens' }
    axios.get(`${API_HOST}/core/exame/options_filters`, { params }).then((response) => {
      this.setState({
        exame: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  fetchAreasConhecimento() {
    const params = { type: 'itens' }
    axios.get(`${API_HOST}/core/area_conhecimento/options_filters`, { params }).then((response) => {
      this.setState({
        area_conhecimento: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  fetchDificuldades() {
    axios.get(`${API_HOST}/itens/dificuldade`).then((response) => {
      this.setState({
        dificuldade: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  fetchCompetencias = debounce((input, callback) => {
    axios
      .get(`${API_HOST}/matriz_referencia/competencia`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        const options = response.data.results.map(mapResponse);
        callback(null, { options });
      });
  }, 1000);

  fetchCriadoPor() {
    axios.get(`${API_HOST}/itens/criado_por`).then((response) => {
      this.setState({
        criado_por: response.data.map((item) => ({
          value: item.id,
          label: `${item.first_name}  ${item.last_name}`
        }))
      });
    });
  }

  fetchStatus() {
    axios.get(`${API_HOST}/itens/status/options_filters`).then((response) => {
      this.setState({
        status: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  fetchTipo() {
    axios.get(`${API_HOST}/itens/tipo/options_filters`).then((response) => {
      this.setState({
        tipo: response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }))
      });
    });
  }

  fetchMatrizReferencia = debounce((input, callback) => {
    const { codigoId, areasConhecimentoId, anoId, componenteCurricularId } =
      this.state;

    const params = {
      status: 1,
      page_size: 100,
      type: 'itens',
      etapa_id: anoId,
    };

    if (componenteCurricularId) {
      params.disciplina_id = componenteCurricularId
    }

    if (codigoId) {
      params.curso__id = codigoId;
    } else {
      if (this.state.cursoID) {
        params.curso__id = this.state.idCursoInitial;
      }
    }

    if (areasConhecimentoId) {
      params.areas_conhecimento__id = areasConhecimentoId;
    } else {
      params.areas_conhecimento__id = '';
    }

    axios
      .get(`${API_HOST}/matriz_referencia/matriz_referencia/options_filters`, { params })
      .then((response) => {
        const options = response.data.map(mapMatrizReferencia);
        this.setState({ matriz_referencia: options });
        callback(null, { options });
      })
      .catch((error) => console.error(error));
  }, 1000);

  fetchComponenteCurricular = debounce((input, callback) => {
    const { areasConhecimentoId } = this.state;
    const params = { type: 'itens', area_conhecimento_id: areasConhecimentoId || '' };
    axios.get(`${API_HOST}/core/componente_curricular/options_filters`, { params }).then((response) => {
      const options = response.data.map((mapResponse) => ({
        value: mapResponse.id,
        label: mapResponse.descricao
      }));
      this.setState({ componenteCurricular: options });
      // callback(null, { options })
    });
  }, 1000);

  fetchCurso = debounce((input, callback) => {
    const params = { type: 'itens' }
    axios
      .get(`${API_HOST}/core/curso/options_filters`, { params })
      .then((response) => {
        const options = [];
        response.data.forEach((mapResponse) => {
          if (mapResponse.oculto !== true) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            });
          }
        });
        callback(null, { options });
      })
      .catch((error) => console.error(error));
  }, 1000);

  fetchPeriodo = debounce((input, callback) => {
    const { cursoId } = this.state;

    if (cursoId) {
      axios
        .get(`${API_HOST}/core/periodo/${cursoId}/filter_curso`)
        .then((response) => {
          const options = []
          response.data.forEach((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options });
          callback(null, { options });
        })
        .catch((error) => console.error(error));
    } else {
      const params = { type: 'itens' }
      axios
        .get(`${API_HOST}/core/periodo/options_filters`, { params })
        .then((response) => {
          const options = [];
          response.data.forEach((mapResponse) => {
            if (mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao
              });
            }
          });
          this.setState({ periodo: options });
          callback(null, { options });
        })
        .catch((error) => console.error(error));
    }
  }, 1000);

  fetchHabilidade = debounce((input, callback) => {
    const {
      areasConhecimentoId,
      componenteCurricularId,
      anoId,
      matrizReferenciaId,
      habilidadeSearch
    } = this.state;

    const params = {
      area_conhecimento_id: areasConhecimentoId,
      matriz_id: matrizReferenciaId,
      etapa_id: anoId,
      disciplina: componenteCurricularId,
      search: habilidadeSearch,
      type: "itens"
    };


    axios
      .get(
        `${API_HOST}/matriz_referencia/habilidade/options_filters`, { params }
      )
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`,
          codigo: `${mapResponse.cd_habilidade}`
        }));
        this.setState({ habilidades: options });

      });
  }, 600);

  fetchEncomendas = debounce((input, callback) => {
    axios
      .get(`${API_HOST}/encomenda/encomenda`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        const options = response.data.results.map(mapEncomenda);
        callback(null, { options });
      });
  }, 1000);

  fetchPalavrasChave(input, callback) {
    axios
      .get(`${API_HOST}/itens/palavra_chave`, {
        params: {
          search: input
        }
      })
      .then((response) => {
        callback(null, {
          options: response.data.results.map((x) => ({
            value: String(x.id),
            label: x.descricao
          }))
        });
      });
  }

  fetchItens() {
    axios.get(`${API_HOST}/itens/item`).then((response) => {
      this.setState({
        itens: response.data.results.map((item) => ({
          id: item.id,
          descricao: item.situacao_problema
        })),
        showItens: true
      });
    });
  }

  toggle = () => {
    const { toggle } = this.props;
    this.values = this.formApi.getState().values;
    toggle();
  };

  handleSubmit = (values) => {
    this.buscarItens(this.getValues(values));
  };

  buscarItens(values) {
    return axios.get(`${API_HOST}/itens/item`, { params: values });
  }

  renderList() {
    return null;
  }

  renderFooter() {
    return null;
  }

  getAvaliationPPI = async (formApi) => {
    try {
      if (this.props.match && this.props.match.params && this.props.match.params.id) {
        const response = await axios.get(`${API_HOST}/avaliacoes/avaliacao?id=${this.props.match.params.id}`);
        const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
        const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;

        this.setState({
          avaliacaoPPI: true,
          areaConhecimentoPPI: response.data.results[0].area_conhecimento,
          areasConhecimentoId: response.data.results[0].area_conhecimento,
          periodoPPI: response.data.results[0].periodo,
          anoId: response.data.results[0].periodo,
          cursoPPI: response.data.results[0].curso[0],
          codigoId: response.data.results[0].codigo,
          componentePPI: response.data.results[0].componente_curricular,
          componenteCurricularId: response.data.results[0].componente_curricular,
          matrizReferenciaId: response.data.results[0].matriz_referencia,
          tipoItemPPI: primeiroTipoItem
        });

        const newInitialValues = {
          ...this.state.initialValues,
          areas_conhecimento: this.state.areaConhecimentoPPI,
          componente_curricular: this.state.componentePPI,
          tipo: this.state.tipoItemPPI,
          periodo: this.state.periodoPPI,
          curso: this.state.cursoPPI,
          matriz_referencia: this.state.matrizReferenciaId,
          habilidade: response.data.results[0].habilidade
        };

        formApi.setValues(newInitialValues);
        this.handleSubmit(newInitialValues);

      } else {
        console.error("Propriedade 'id' não encontrada em this.props.match.params");
      }
    } catch (e) {
      console.error("Erro na requisição:", e);
    }
  };

  getAvaliation = async (formApi) => {
    try {
      if (this.props.match && this.props.match.params && this.props.match.params.id) {
        const response = await axios.get(`${API_HOST}/avaliacoes/avaliacao?id=${this.props.match.params.id}`);
        const tipo_itens = JSON.parse(response.data.results[0].tipo_itens);
        const primeiroTipoItem = tipo_itens != null ? tipo_itens[0] : null;
        const areaConhecimento = response.data.results[0].area_conhecimento;

        this.setState({
          areaConhecimentoID: parseInt(areaConhecimento),
          periodoID: response.data.results[0].periodo,
          cursoID: response.data.results[0].curso[0],
          componenteID: response.data.results[0].componente_curricular,
          tipoItemID: primeiroTipoItem
        });

        const newInitialValues = {
          ...this.state.initialValues,
          areas_conhecimento: this.state.areaConhecimentoID,
          componente_curricular: this.state.componenteID,
          tipo: this.state.tipoItemID,
          periodo: this.state.periodoID,
          curso: this.state.cursoID,
          habilidade: response.data.results[0].habilidade,
          matriz_referencia: this.state.matrizReferenciaId,
        };

        formApi.setValues(newInitialValues);
      } else {
        console.error("Propriedade 'id' não encontrada em this.props.match.params");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  resetForm = () => {
    this.setState({ areasConhecimentoId: '', areaConhecimentoPPI: '', areaConhecimentoID: '' })
    this.setState({ cursoID: '', cursoPPI: '' })
    this.setState({ componenteCurricularId: '', componentePPI: '', componenteID: '' })
    this.setState({ anoId: '', periodoPPI: '', periodoID: '' })
    this.setState({ matrizReferenciaId: '' })
    this.setState({ habilidadeSearch: '' })
    this.setState({ tipoItemPPI: '', tipoItemID: '' })
    this.formApi.reset();
  }


  renderForm() {
    const {
      area_conhecimento,
      criado_por,
      tipo,
      isChecked,
      matriz_referencia,
      habilidades,
      periodo,
      componenteCurricular,
    } = this.state;
    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        onValueChange={this.onValueChange}
        onSubmit={this.handleSubmit}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >

        <Grid item container xs={12}>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  style={{
                    color: "#333",
                    fontFamily: "Public Sans",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                  }}
                >
                  Filtros
                </Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Typography
                  style={{
                    color: "#0047B6",
                    fontFamily: "Public Sans",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                    marginLeft: "1rem",
                    cursor: "pointer",
                    marginBottom: "1rem"
                  }}
                  onClick={() => { this.resetForm() }}
                >
                  Remover Filtros
                </Typography>
              </div>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              {this.shouldDisplay('avaliacao.filterForText') ? (
                <>
                  <Grid item xs={12}>
                    <InputTextArea
                      label="Enunciado"
                      field="enunciado"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputTextArea
                      label="Alternativa"
                      field="alternativa"
                    />
                  </Grid>

                </>
              ) : (
                <></>
              )}
            </Grid>
            {/* <Grid item xs={12}>
              <Grid item xs={12}>
                <InputSelectAsyncCreatable
                  multi
                  label="Palavras-chave"
                  field="palavras_chave"
                  loadOptions={this.fetchPalavrasChave}
                  autoload={false}
                />
              </Grid>
              {/* <InputKeyWordsActivity
                field="keyWords"
                showButtonAdd={false}
              /> */}
            {/* </Grid> */}
            <Grid item container xs={12}>
              <Grid item container xs={12}>
                <Grid item xs={12} >
                  <FormSeparator>
                    <Typography
                      style={{
                        marginTop: "20px",
                        color: "#262930",
                        fontFamily: "Public Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "normal",
                      }}
                    >
                      Dados da aplicação
                    </Typography>
                  </FormSeparator>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <InputSelectAsync
                    autoload
                    label="Segmento/Etapa"
                    field="curso"
                    value={this.state.avaliacaoPPI ? this.state.cursoPPI : this.state.cursoID}
                    onChange={
                      (event) => event ? (
                        this.setState({
                          codigoId: event.codigo,
                          cursoId: event.value,
                          cursoPPI: event.value,
                          cursoID: event.value
                        }),
                        this.fetchMatrizReferencia(),
                        this.fetchPeriodo(),
                        this.formApi.setValue('periodo', null)
                      ) : (
                        this.setState({ codigoId: '', cursoId: '', cursoPPI: '', cursoID: '' }),
                        this.fetchMatrizReferencia(),
                        this.fetchPeriodo(),
                        this.formApi.setValue('periodo', null),
                        this.formApi.setValue('curso', null)
                      )
                    }
                    loadOptions={this.fetchCurso}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputSelect
                    label="Série/Ano"
                    field="periodo"
                    value={this.state.avaliacaoPPI ? this.state.periodoPPI : this.state.periodoID ? this.state.periodoID : ''}
                    onChange={(event) =>
                      event
                        ? (this.setState({ anoId: event.value, periodoPPI: event.value, periodoID: event.value }),
                          this.fetchMatrizReferencia())
                          // this.fetchHabilidade(), this.fetchMatrizReferencia())
                        : (this.setState({ anoId: '', periodoPPI: '', anoID: '', periodoID: '' }), this.fetchMatrizReferencia())
                    }
                    options={periodo}
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputSelect
                    label="Área do Conhecimento"
                    field="area_conhecimento"
                    value={
                      this.state.avaliacaoPPI ? (
                        this.state.areaConhecimentoPPI
                      ) : (
                        this.state.areasConhecimentoId ? (
                          ""
                        ) : (
                          this.state.areaConhecimentoID
                        )
                      )
                    }
                    options={area_conhecimento}
                    onChange={(event) =>
                      event ? (
                        this.setState({
                          areasConhecimentoId: event.value,
                          areaConhecimentoPPI: event.value,
                          areaConhecimentoID: event.value
                        }),
                        this.formApi.setValue('componente_curricular', null),
                        this.fetchMatrizReferencia(),
                        // this.fetchHabilidade(),
                        this.fetchComponenteCurricular()
                      ) : (
                        this.formApi.setValue('area_conhecimento', null),
                        this.formApi.setValue('componente_curricular', null),
                        this.setState({ areasConhecimentoId: '', areaConhecimentoPPI: '' }),
                        this.fetchMatrizReferencia(),
                        // this.fetchHabilidade(),
                        this.fetchComponenteCurricular()
                      )
                    }
                  />
                </Grid>

                {this.state.cursoID == 6 || this.state.cursoID == 10 ? (
                  <></>
                ) : (
                  <Grid item xs={12}>
                    <InputSelect
                      label="Componente Curricular"
                      field="componente_curricular"
                      value={this.state.avaliacaoPPI ? this.state.componentePPI : this.state.componenteID ? this.state.componenteID : ''}
                      onChange={(event) =>
                        event
                          ? (this.setState({ componenteCurricularId: event.value, componentePPI: event.value, componenteID: event.value }),
                            this.fetchMatrizReferencia())
                          : (
                            this.fetchMatrizReferencia(),
                            this.setState({ componenteID: '', componenteCurricularId: "", componentePPI: "" }),
                            this.formApi.setValue('componente_curricular', null)
                          )
                      }
                      options={componenteCurricular}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid item container xs={12}>

                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <FormSeparator>
                    <Typography
                      style={{
                        marginTop: "20px",
                        color: "#262930",
                        fontFamily: "Public Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "normal",
                      }}
                    >
                      Habilidades
                    </Typography>
                  </FormSeparator>
                </Grid>
                <Grid item xs={12} >
                  {this.shouldDisplay('avaliacao.renderMatrizHabilidade') ? (
                    <div>
                      <Grid item xs={12} style={{ marginTop: "1rem" }}>
                        <InputSelect
                          label="Matriz de Referência"
                          field="matriz_referencia"
                          onChange={(event) => {
                            this.formApi.setValue('habilidade', null)

                            if (event) {
                              this.setState({ matrizReferenciaId: event.value })
                              this.fetchHabilidade()
                            } else {
                              this.formApi.setValue('matriz_referencia', null)
                              this.setState({ matrizReferenciaId: '' })
                              this.fetchHabilidade()
                            }
                          }}
                          options={matriz_referencia}
                        />
                      </Grid>
                      {/* <InputSelectAsync
                          autoload
                          label="Competências"
                          col="col-md-12"
                          field="competencia"
                          loadOptions={this.fetchCompetencias}
                        /> */}
                      <Grid item xs={12}>
                        <InputSelectMulti
                          multi
                          label="Habilidade"
                          field="habilidade"
                          options={habilidades}
                          onChange={(event) => {
                            if (!event) {
                              this.setState({ habilidadeSearch: '' })
                              this.formApi.setValue('habilidade', null)
                            }
                          }}
                          onInputChange={(event) => {
                            if (event) {
                              this.setState({ habilidadeSearch: event });
                              this.fetchHabilidade();
                            }
                          }}
                        />
                      </Grid>
                    </div>
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={12}>
                  <FormSeparator>
                    <Typography
                      style={{
                        marginTop: "20px",
                        color: "#262930",
                        fontFamily: "Public Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "normal",
                      }}
                    >
                      Classificação
                    </Typography>
                  </FormSeparator>
                </Grid>

                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <InputSelect
                    label="Tipo do Objeto de aprendizagem"
                    field="tipo"
                    options={tipo}
                    value={this.state.avaliacaoPPI ? this.state.tipoItemPPI : this.state.tipoItemID}
                    onChange={(event) => this.setState({
                      tipoItemPPI: event ? event.value : this.setState({ tipoItemPPI: '', tipoItemID: '' }),
                      tipoItemID: event && event.value,
                    })}
                  />
                </Grid>

                {/* <Grid item xs={12}>
                  <Grid item={12}>
                    <InputSelect
                      label="Status do Objeto de aprendizagem"
                      field="status"
                      options={status}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <InputSelect
                    label="Categoria"
                    field="exame"
                    options={exame}
                  />
                </Grid> */}

                {this.shouldDisplay('avaliacao.filterCode') ? (
                  <Grid item xs={12}>
                    <InputText
                      label="Código do Objeto de aprendizagem"
                      field="id"
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {this.shouldDisplay('avaliacao.filterExternalId') ? (
                  <Grid item xs={12}>
                    <InputText
                      label="Código Externo"
                      field="external_id"
                    />
                  </Grid>
                ) : (
                  <></>
                )}
                {this.shouldDisplay('avaliacao.elaborador') && (
                  <Grid item xs={12}>
                    <InputSelect
                      label="Elaborador"
                      field="criado_por"
                      options={criado_por}
                    />
                  </Grid>
                )}


                {this.shouldDisplay('avaliacao.filtersWithDate') ? (
                  <>
                    <Grid item xs={12}>
                      <InputDate
                        label="Itens criados a partir de"
                        field="min_criado_em"
                        type="date"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputDate
                        label="Itens criados até"
                        field="max_criado_em"
                        type="date"
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
              {this.shouldDisplay('avaliacao.itensPublicos') && (
                <Grid item container xs={12}>
                  <Grid item xs={12}>
                    <FormSeparator>
                      <Typography
                        style={{
                          marginTop: "20px",
                          color: "#262930",
                          fontFamily: "Public Sans",
                          fontSize: "16px",
                          fontStyle: "normal",
                          fontWeight: 600,
                          lineHeight: "normal",
                        }}
                      >
                        Visualização
                      </Typography>
                    </FormSeparator>
                  </Grid>
                  {this.shouldDisplay('avaliacao.renderMochilaTopicoSubtopico') ? (
                    <div className="row modal-body-inside">
                      <InputText label="Mochila" field="mochila" col="col-md-4" />
                      <InputText label="Topico" field="topico" col="col-md-4" />
                      <InputText label="SubTopico" field="subtopico" col="col-md-4" />
                    </div>
                  ) : (
                    <></>
                  )}

                  {this.shouldDisplay('avaliacao.nuncaUtilizados') && (
                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                      <InputCheckbox
                        required
                        label="Mostrar somente itens nunca utilizados em avaliações"
                        field="nunca_utilizados"
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <InputCheckbox
                      required
                      label="Mostrar somente itens públicos"
                      field="publico"
                      onChange={(e) => this.setState({ isChecked: e.target.checked })}
                      checked={isChecked}
                      value={isChecked}
                    ></InputCheckbox>
                  </Grid>
                </Grid>
              )}

              <Grid item container xs={12}>
                {this.shouldDisplay('avaliacao.renderEncomendaFilter') ? (
                  <>
                    <Grid item xs={12}>
                      <InputSelectAsync
                        label="Título"
                        field="encomenda"
                        loadOptions={this.fetchEncomendas}
                        autoload={false}
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
                {this.shouldDisplay('avaliacao.renderTCT') ? (
                  <>
                    <Grid item xs={12}>
                      <InputSpan
                        field="min_bisserial"
                        label="Bisserial"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        field="max_bisserial"
                        leftAddon="Máximo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        field="min_discriminacao"
                        label="Discriminação"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        field="max_discriminacao"
                        leftAddon="Máximo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        field="min_dificuldade"
                        label="Dificuldade (porcentagem de acertos)"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        field="max_dificuldade"
                        leftAddon="Máximo"
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

                {this.shouldDisplay('avaliacao.renderTRI') ? (
                  <>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="min_pa"
                        label="A"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="max_pa"
                        leftAddon="Máximo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="min_pb"
                        label="B"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="max_pb"
                        leftAddon="Máximo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="min_pc"
                        label="C"
                        leftAddon="Mínimo"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <InputSpan
                        col="col-4"
                        field="max_pc"
                        leftAddon="Máximo"
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Fab
            style={{
              width: "149px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: '10px',
              marginLeft: "210px",
              background: "#0047B6",
              color: "#ffffff",
              padding: "9px 30px",
              borderRadius: "70px",
              outline: "none",
              fontWeight: "600",
              textAlign: "center",
              textTransform: "capitalize",
            }}
            // target="_blank"
            variant="extended"
            onClick={() => { this.handleSubmit() }}
          >
            <Typography
              style={{
                color: "#FFFFFF",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                letterSpacing: '0em',
              }}
            >
              Buscar
            </Typography>
          </Fab>
        </Grid>
      </Form>
    );
  }

  renderFormObjeto() {
    const {
      exame,
      area_conhecimento,
      criado_por,
      status,
      tipo,
      dificuldade,
      isPublic,
      isChecked,
      formState,
      matriz_referencia,
      habilidades,
      periodo,
      componenteCurricular,
      componenteCurricularId,
      codigoId,
      cursoId,
      habilidadeSearch
    } = this.state;
    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        onValueChange={this.onValueChange}
        onSubmit={this.handleSubmit}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
      >
        <Grid item container xs={12}>
          <Grid item container xs={12}>
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    marginTop: "20px",
                    color: "#262930",
                    fontFamily: "Public Sans",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                  }}
                >
                  Dados da aplicação
                </Typography>
              </Grid>
              <Grid item container xs={12} style={{ marginTop: "1rem" }}>

                <Grid item xs={6}>
                  <InputSelectAsync
                    autoload
                    label="Segmento/Etapa"
                    field="curso"
                    value={this.state.avaliacaoPPI ? this.state.cursoPPI : this.state.cursoID}
                    onChange={(event) =>

                      event
                        ? (this.setState({
                          codigoId: event.codigo,
                          cursoId: event.value,
                          cursoPPI: event.value,
                          cursoID: event.value
                        }),
                          this.setState({ anoId: '', periodoPPI: '', anoID: '', periodoID: '' }),
                          this.fetchMatrizReferencia(),
                          this.fetchPeriodo())
                        : (this.setState({ codigoId: '', cursoId: '', cursoPPI: '', cursoID: '' }),
                          this.setState({ anoId: '', periodoPPI: '', anoID: '', periodoID: '' }),
                          this.fetchMatrizReferencia(),
                          this.fetchPeriodo())
                    }
                    loadOptions={this.fetchCurso}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputSelect
                    label="Série/Ano"
                    field="periodo"
                    value={this.state.avaliacaoPPI ? this.state.periodoPPI : this.state.periodoID ? this.state.periodoID : ''}
                    onChange={(event) =>
                      event
                        ? (this.setState({ anoId: event.value, periodoPPI: event.value, periodoID: event.value }),
                          this.fetchMatrizReferencia())
                        : (this.setState({ anoId: '', periodoPPI: '', anoID: '', periodoID: '' }), this.fetchMatrizReferencia())
                    }
                    options={periodo}

                  />
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={6} >
                  <InputSelect
                    label="Área do Conhecimento"
                    field="area_conhecimento"
                    value={this.state.avaliacaoPPI ? this.state.areaConhecimentoPPI : this.state.areaConhecimentoID ? this.state.areaConhecimentoID : ''}
                    options={area_conhecimento}
                    onChange={(event) =>
                      event
                        ? (this.setState({ areasConhecimentoId: event.value, areaConhecimentoPPI: event.value, areaConhecimentoID: event.value }),
                          this.fetchMatrizReferencia(),
                          this.fetchComponenteCurricular())
                        : (this.setState({ areasConhecimentoId: '', areaConhecimentoPPI: '', areaConhecimentoID: '' }),
                          this.fetchMatrizReferencia(),
                          this.fetchComponenteCurricular())
                    }
                  />
                </Grid>
                {this.state.cursoID == 6 || this.state.cursoID == 10 ? (
                  <></>
                ) : (
                  <Grid item xs={6}>
                    <InputSelect
                      label="Componente Curricular"
                      field="componente_curricular"
                      value={this.state.avaliacaoPPI ? this.state.componentePPI : this.state.componenteID ? this.state.componenteID : ''}
                      onChange={(event) =>
                        event
                          ? (this.setState({ componenteCurricularId: event.value, componentePPI: event.value, componenteID: event.value }),
                            this.fetchMatrizReferencia())
                          : (
                            this.fetchMatrizReferencia(),
                            this.setState({ componenteID: '' })
                          )
                      }
                      options={componenteCurricular}
                    />
                  </Grid>)}
              </Grid>
            </Grid>
            <Grid item container xs={12}>

              <Grid item xs={12} style={{ marginTop: "1rem" }}>
                <FormSeparator>
                  <Typography
                    style={{
                      marginTop: "20px",
                      color: "#262930",
                      fontFamily: "Public Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Habilidades
                  </Typography>
                </FormSeparator>
              </Grid>
              <Grid item xs={12} style={{ marginTop: "1rem" }}>
                {this.shouldDisplay('avaliacao.renderMatrizHabilidade') ? (
                  <div style={{ display: 'flex' }}>
                    <Grid item xs={6} >
                      <InputSelect
                        label="Matriz de Referência"
                        field="matriz_referencia"
                        onChange={(event) => {
                          this.formApi.setValue('habilidade', null)
                          this.forceUpdate()

                          if (event) {
                            this.setState({ matrizReferenciaId: event.value })
                            this.fetchHabilidade()
                          } else {
                            this.setState({ matrizReferenciaId: '' })
                            this.fetchHabilidade()
                          }
                        }}
                        options={matriz_referencia}
                      />
                    </Grid>
                    {/* <InputSelectAsync
                          autoload
                          label="Competências"
                          col="col-md-12"
                          field="competencia"
                          loadOptions={this.fetchCompetencias}
                        /> */}
                    <Grid item xs={6}>
                      <InputSelect
                        label="Habilidade"
                        field="habilidade"
                        options={habilidades}
                        onChange={(event) => {
                          if (!event) {
                            this.setState({ habilidadeSearch: '' })
                            this.fetchHabilidade()
                          }
                        }}
                        onInputChange={(event) => {
                          if (event) {
                            this.setState({ habilidadeSearch: event })
                            this.fetchHabilidade()
                          }
                        }}
                      />
                    </Grid>
                  </div>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
            <Grid item container xs={12}>
              <Grid item xs={12}>
                <FormSeparator>
                  <Typography
                    style={{
                      marginTop: "20px",
                      color: "#262930",
                      fontFamily: "Public Sans",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Classificação
                  </Typography>
                </FormSeparator>
              </Grid>
              <Grid item xs={12} style={{ marginTop: "1rem" }} >
                <div style={{ display: 'flex' }}>
                  <Grid item xs={4} >
                    <InputSelect
                      label="Tipo do Objeto de aprendizagem"
                      field="tipo"
                      options={tipo}
                      value={this.state.avaliacaoPPI ? this.state.tipoItemPPI : this.state.tipoItemID}
                      onChange={(event) => this.setState({
                        tipoItemPPI: event ? event.value : this.setState({ tipoItemPPI: '', tipoItemID: '' }),
                        tipoItemID: event && event.value,
                      })}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <InputSelect
                      label="Situação do objeto"
                      field="status"
                      options={status}
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <InputSelect
                      label="Categoria"
                      field="exame"
                      options={exame}
                    />
                  </Grid>
                </div>
                <div style={{ display: 'flex' }}>
                  {this.shouldDisplay('avaliacao.filterCode') ? (
                    <Grid item xs={6} style={{ marginRight: '8px' }}>
                      <InputText
                        label="Código do Objeto de aprendizagem"
                        field="id"
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                  {this.shouldDisplay('avaliacao.filterExternalId') ? (
                    <Grid item xs={6} style={{ marginLeft: '8px' }}>
                      <InputText
                        label="Código Externo"
                        field="external_id"
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                </div>
                {this.shouldDisplay('avaliacao.elaborador') && (
                  <Grid item xs={4}>
                    <InputSelect
                      label="Elaborador"
                      field="criado_por"
                      options={criado_por}
                    />
                  </Grid>
                )}


                {this.shouldDisplay('avaliacao.filtersWithDate') ? (
                  <>
                    <Grid item xs={4}>
                      <InputDate
                        label="Itens criados a partir de"
                        field="min_criado_em"
                        type="date"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputDate
                        label="Itens criados até"
                        field="max_criado_em"
                        type="date"
                      />
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

              </Grid>
            </Grid>
            {this.shouldDisplay('avaliacao.itensPublicos') && (
              <Grid item container xs={12}>
                <Grid item xs={12}>
                  <FormSeparator>
                    <Typography
                      style={{
                        marginTop: "20px",
                        color: "#262930",
                        fontFamily: "Public Sans",
                        fontSize: "16px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "normal",
                      }}
                    >
                      Visualização
                    </Typography>
                  </FormSeparator>
                </Grid>
                {this.shouldDisplay('avaliacao.renderMochilaTopicoSubtopico') ? (
                  <div className="row modal-body-inside">
                    <InputText label="Mochila" field="mochila" col="col-md-4" />
                    <InputText label="Topico" field="topico" col="col-md-4" />
                    <InputText label="SubTopico" field="subtopico" col="col-md-4" />
                  </div>
                ) : (
                  <></>
                )}
                <Grid item xs={12} style={{ marginTop: "2rem" }}>
                  <InputCheckbox
                    required
                    label="Mostrar somente itens nunca utilizados em avaliações"
                    field="nunca_utilizados"
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputCheckbox
                    required
                    label="Mostrar somente itens públicos"
                    field="publico"
                    onChange={(e) => this.setState({ isChecked: e.target.checked })}
                    checked={isChecked}
                    value={isChecked}
                  ></InputCheckbox>
                </Grid>
              </Grid>
            )}

            <Grid item xs={12} >
              {this.shouldDisplay('avaliacao.filterForText') ? (
                <>
                  <Grid item xs={6}>
                    <InputTextArea
                      label="Enunciado"
                      field="enunciado"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputTextArea
                      label="Alternativa"
                      field="alternativa"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <InputSelectAsyncCreatable
                      multi
                      label="Palavras-chave"
                      field="palavras_chave"
                      loadOptions={this.fetchPalavrasChave}
                      autoload={false}
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}

            </Grid>

            <Grid item container xs={12}>
              {this.shouldDisplay('avaliacao.renderEncomendaFilter') ? (
                <>
                  <Grid item xs={4}>
                    <InputSelectAsync
                      label="Título"
                      field="encomenda"
                      loadOptions={this.fetchEncomendas}
                      autoload={false}
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
              {this.shouldDisplay('avaliacao.renderTCT') ? (
                <>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_bisserial"
                      label="Bisserial"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_bisserial"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_discriminacao"
                      label="Discriminação"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_discriminacao"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="min_dificuldade"
                      label="Dificuldade (porcentagem de acertos)"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      field="max_dificuldade"
                      leftAddon="Máximo"
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}

              {this.shouldDisplay('avaliacao.renderTRI') ? (
                <>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pa"
                      label="A"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pa"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pb"
                      label="B"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pb"
                      leftAddon="Máximo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="min_pc"
                      label="C"
                      leftAddon="Mínimo"
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <InputSpan
                      col="col-4"
                      field="max_pc"
                      leftAddon="Máximo"
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Form>
    );
  }

  render() {
    const { isOpen } = this.props;

    const styles = (theme) => ({
      root: {
        margin: 0,
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center',
      },
      closeButton: {
        right: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });



    const DialogTitle = withStyles(styles)((props) => {
      const { children, classes, onClose, ...other } = props;
      return (
        <MuiDialogTitle disableTypography className={classes.root} {...other} >
          <Typography
            variant="h6"
            style={{
              color: "#333",
              fontFamily: 'Public Sans',
              fontSize: '20px',
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            {children}
          </Typography>

          <IconButton onClick={this.toggle} >
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
      );
    });

    return (
      <Dialog
        open={isOpen}
        toggle={this.toggle}
        maxWidth="md"
        fullWidth={false}
        aria-labelledby="responsive-dialog-title"
        onEnter={this.onOpened}
        onClosed={this.onExit}
      >

        <DialogTitle toggle={this.toggle}>Buscar Objetos de Aprendizagem</DialogTitle>

        <DialogContent dividers>
          <div>
            <Typography
              style={{
                fontFamily: 'Public Sans',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '14px',
                letterSpacing: '0px',
                textAlign: 'left',
                color: '#676A71'

              }}
            >
              Para buscar pelos Objetos de Aprendizagem, não é necessário preencher todos os campos. Busque pelo que deseja filtrar.
            </Typography>
          </div>
          <Grid container
            style={{
              width: '100%',
              overflow: 'auto'
            }}>
            {this.renderFormObjeto()}
          </Grid>
        </DialogContent>

        <DialogActions style={{ padding: "12px 30px 12px 0px" }}>
          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              background: "#E4E4E4",
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}

          >
            <Typography
              style={{
                color: "#878787",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',
              }}
              onClick={this.toggle}
            >
              Cancelar
            </Typography>
          </Button>

          <Button
            style={{
              width: "149px",
              padding: "9px 30px",
              gap: "15px",
              borderRadius: "70px",
              background: "#0047B6",
              boxShadow: "2px 2px 7px 0px rgba(0, 0, 0, 0.25)",
              textTransform: "capitalize",
            }}
            onClick={() => { this.handleSubmit() }}
          >
            <Typography
              style={{
                color: "#FFFFFF",
                fontFamily: "Public Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: '0em',
                textAlign: 'center',

              }}

            >
              Buscar
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default BaseFiltroAvancadoItem;
